"use strict";

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header");
const headerRects = HEADER.getBoundingClientRect();
const headerHeight = headerRects.height + headerRects.top;

let lastScrollTop = 0;

document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);

const animateTo = (target) => {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - headerHeight * 1.25;
	const duration = 1400;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
};

const scrollW = () => {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}
	lastScrollTop = Math.max(scrollTop, 0);
};

(() => {
	window.addEventListener('scroll', scrollW);

	// DOM CLEANUP (TinyMCE)
	for (const p of document.getElementsByTagName("p"))
		p.children.length === 0 && p.textContent.trim() === '' && p.remove();

	// SCROLL ANIMATIONS (Hash Links)
	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx])').forEach(cta => {
		const target = cta.hash.substring(1);
		if (!document.getElementById(target)) return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// TOGGLE BUTTONS
	const toggleGroups = new Map();

	const getPanel = (el) => {
		const target = el.dataset.target;
		if (target)
			return document.getElementById(target);

		const next = el.nextElementSibling;
		return (next && next.hasAttribute('aria-expanded')) ? next : null;
	};

	const deactivate = (currentlyActive) => {
		currentlyActive.summary.classList.remove("active");
		currentlyActive.content && currentlyActive.content.setAttribute("aria-expanded", false);
	};

	document.addEventListener("click", (e) => {
		const el = e.target.closest(".js-toggle-active");
		if (!el) return;

		const groupKey = el.dataset.group || el,
			action = el.dataset.action || "toggle",
			currentlyActive = toggleGroups.get(groupKey);

		if (action === "close") {
			if (currentlyActive) {
				deactivate(currentlyActive);
				toggleGroups.delete(groupKey);
			}
			return;
		}

		currentlyActive && currentlyActive.summary !== el && deactivate(currentlyActive);

		const panel = getPanel(el);

		if (action === "open") {
			el.classList.add("active");
			panel && panel.setAttribute("aria-expanded", "true");
			toggleGroups.set(groupKey, { summary: el, content: panel });
			return;
		}

		const nowActive = el.classList.toggle("active");
		panel && panel.setAttribute("aria-expanded", nowActive);

		if (nowActive)
			toggleGroups.set(groupKey, { summary: el, content: panel });
		else
			toggleGroups.delete(groupKey);
	});

	// OBSERVERS
	const animationObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add("fade-in");
				animationObserver.unobserve(entry.target);
			}
		});
	});

	const animateObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			entry.target.classList.toggle("visible", entry.intersectionRatio > 0.6);
		});
	}, { threshold: [0.6] });

	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const el = entry.target;
			const targetEl = el.dataset.target ? document.getElementById(el.dataset.target) : el;
			targetEl && targetEl.style.setProperty("--offset", `${el.scrollHeight}px`);
		});
	});

	// DYNAMIC ELEMENT INITIALIZER
	const initDynamicElements = (container = document) => {
		container.querySelectorAll(".global-sitemap, .form-module-wrapper").forEach(item => {
			item.classList.add("animate-fade", "top");
		});

		container.querySelectorAll(".animate-fade").forEach(el => animationObserver.observe(el));
		container.querySelectorAll(".animate").forEach(el => animateObserver.observe(el));
		container.querySelectorAll(".js-offset").forEach(el => resizeObserver.observe(el));

		container.querySelectorAll(".js-toggle-active.active").forEach(el => {
			const key = el.dataset.group || el;
			toggleGroups.set(key, { summary: el, content: getPanel(el) });
		});
	};

	initDynamicElements();

	let observerTimeout;

	const domObserver = new MutationObserver(mutations => {
		let shouldUpdate = false;

		for (const mutation of mutations) {
			if (mutation.addedNodes.length > 0) {
				for (const node of mutation.addedNodes) {
					if (node.nodeType === 1) {
						shouldUpdate = true;
						break;
					}
				}
			}
			if (shouldUpdate) break;
		}

		if (shouldUpdate) {
			clearTimeout(observerTimeout);
			observerTimeout = setTimeout(() => {
				initDynamicElements();
			}, 50);
		}

		for (const [key, val] of toggleGroups.entries()) {
			if (!document.contains(val.summary)) {
				toggleGroups.delete(key);
			}
		}
	});

	domObserver.observe(document.body, { childList: true, subtree: true });
})();
//Functions ADA 

	document.addEventListener('DOMContentLoaded', function(){
		const svgitm = document.querySelectorAll('svg:not([aria-label])');
		if(svgitm){
			svgitm.forEach( svg =>{
				svg.setAttribute('aria-hidden', 'true')
			})
		}
	});

	document.addEventListener('DOMContentLoaded', function(){
		const termlyBtn = document.getElementById('termly-consent-preferences');
		if(termlyBtn){
			termlyBtn.setAttribute('role', 'button');
		}
	});

	document.addEventListener('DOMContentLoaded', function(){
		const emailLinks = document.querySelectorAll('a[href^="mailto:"]');
		emailLinks.forEach(link => {
			const visibleText = link.textContent.trim();
			link.setAttribute('aria-label', `${visibleText} (opens in your mail application)`);
		});
	});
//End functions